import React, { useEffect, useRef, useState } from "react";
import { IoWarningOutline } from "react-icons/io5";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useParams } from "react-router-dom";
import http from "../../Api";
import { ImageUrl } from "../../utils";
import ChatItem from "../ChatItem";
import LoadingFile from "../ChatItem/LoadingFile";
import FileItem from "../FileItem";
export default function ListMessage({ roomId, roomName, onReportClick, UploadImages = [], CnacelUpload, messages = [] }) {
  const api = http();
  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const listRef = useRef();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      listRef.current?.lastElementChild?.scrollIntoView();
      api.UpdateIsRead(({ data }) => { }, id);
    }
    return () => { };
  }, [id,messages.length]);
  useEffect(() => {
    listRef.current?.lastElementChild?.scrollIntoView();
    return () => { };
  }, [UploadImages.length]);


  const types = {
    Text: 0,
    Photo: 1,
    File: 2,
    Voice: 3,
  };
  function MessageRender(type, text) {
    switch (type) {
      case types.File:
        return <FileItem title={text} link={ImageUrl("ChatFile/" + text)} />;
      case types.Photo:
        return (
          <Zoom className={"w-100"}>
            <img
              alt={text}
              className="w-100 rounded-3"
              style={{ maxHeight: "40vh" }}
              src={ImageUrl("ChatPhoto/" + text)}
            />
          </Zoom>
        );
      case types.Voice:
        return (
          <audio
            src={ImageUrl("ChatVoice/" + text)}
            controls
            type="audio/*"
            className="w-100"
          />
        );
      case types.Text:
        return <p className="w-100">{text}</p>;

      default:
        break;
    }
  }
  if (!roomId) {
    return (
      <div
        className="row justify-content-center align-items-center"
        style={{ height: "70vh", overflowY: "scroll" }}
      >
        <div className="col-auto mx-auto">
          <h5 className="text-center">از سمت راست یک گفتگو را انتخاب کنید</h5>
        </div>
      </div>
    );
  }
  return (
    <div className="row  " >
      <div
        className="col-12 d-flex align-items-center justify-content-between"
        style={{ borderBottom: "2px solid #e2e2e2" }}
      >
        <h6 className="mt-2">{roomName} </h6>
        <IoWarningOutline
          color="#777"
          size={30}
          onClick={() => onReportClick()}
        />
      </div>
      <div
        className="row mt-1 pb-3"
        style={{ height: "70vh", overflowY: 'scroll' }}
        ref={listRef}
      >
        {messages.map((item) => (
          <ChatItem
            key={item.id}
            img={item.imageProfile}
            senderName={item.senderName}
            sendDate={item.sendTime}
            isSender={item.myMessage}
            isRead={item.isRead}
            onRemove={() => {
              var form = new FormData();
              form.append("messageId", item.id);
              api.RemoveMessage(({ data }) => { }, form);
            }}
          >
            {MessageRender(item.type, item.text)}
          </ChatItem>
        ))}

        {UploadImages.map((item, index) =>
          <LoadingFile
            key={index}
            isSender={true}
            isRead={false}
            onRemove={() => {
              CnacelUpload()
              console.log("cancel click...")
            }}
          >
            <Zoom className={"w-100"}>
              <img
                alt={"text"}
                className="w-100 rounded-3"
                style={{ maxHeight: "40vh" }}
                src={item.src}
              />
            </Zoom>
            <div class="btn btn-primary mt-3" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="sr-only">{item.percent}%</span>
            </div>
          </LoadingFile>
        )}
      </div>
    </div>
  );
}
